import SearchText from './SearchText.client'
export default SearchText
